import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_EMPLOYEE_MASTER,
    getEmployeeMasterFail,
    getEmployeeMasterSuccess
} from '../action/getEmployeeMasterAction'

// api 
import getEmployeeMasterApi from '../api/getEmployeeMasterApi'

export function* getEmployeeMasterSaga(action) {
    try {
        const response = yield call(() => getEmployeeMasterApi(action.params))
        if (response.data.status === 1) {
            yield put(getEmployeeMasterSuccess(response, action))
        } else {
            yield put(getEmployeeMasterFail(response, action))
        }
    }
    catch (e) {
        yield put(getEmployeeMasterFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_EMPLOYEE_MASTER, getEmployeeMasterSaga)
}